import { Tag } from 'antd';
import styled from 'styled-components';
import { BRAND } from '@/constants/brand';

export const PrimaryTag = styled(Tag)`
  border-color: rgba(97, 97, 215, 0.65);
  background-color: rgba(97, 97, 215, 0.42);
  color: #ffffff;

  /* White on a 42% lavanda tint over white is under 2:1; ink on a paler one reads. */
  html[data-theme='light'] && {
    border-color: rgba(97, 97, 215, 0.35);
    background-color: rgba(97, 97, 215, 0.14);
    color: ${BRAND.ink};
  }
`;

export const ChannelTag = styled(PrimaryTag)`
  text-transform: uppercase;
  margin: 0;
`;

export const RoleTag = styled(PrimaryTag)`
  border: none;

  &.admin {
    color: ${({ theme }) => theme.color.cyan_8};
    background-color: ${({ theme }) => theme.color.cyan_1};
  }
  &.super-admin {
    color: ${({ theme }) => theme.color.primary_6};
    background-color: ${({ theme }) => theme.color.primary_2};
  }
  &.account-manager {
    color: ${({ theme }) => theme.color.magenta_8};
    background-color: ${({ theme }) => theme.color.magenta_1};
  }
  &.finance-manager {
    color: ${({ theme }) => theme.color.polar_green_8};
    background-color: ${({ theme }) => theme.color.polar_green_1};
  }
  &.lead-trader {
    color: ${({ theme }) => theme.color.volcano_8};
    background-color: ${({ theme }) => theme.color.volcano_1};
  }
  &.trader {
    color: ${({ theme }) => theme.color.geek_blue_8};
    background-color: ${({ theme }) => theme.color.geek_blue_1};
  }
  &.rate-builder {
    color: ${({ theme }) => theme.color.cyan_8};
    background-color: ${({ theme }) => theme.color.cyan_1};
  }
`;
